module.exports = __webpack_public_path__ + "img/as.ebb67d84.svg";